/* eslint-disable */
import * as Types from '../../../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IntegrationSettings_AddMutationVariables = Types.Exact<{
  input: Types.AddOrganisationIntegrationInput;
}>;


export type IntegrationSettings_AddMutation = { addOrganisationIntegration: { __typename: 'AddOrganisationIntegrationResult', organisationIntegration: { __typename: 'OrganisationIntegration', id: string, settings: any, integration: { __typename: 'Integration', integrationId: Types.IntegrationId } } } };

export type IntegrationSettings_UpdateMutationVariables = Types.Exact<{
  input: Types.UpdateOrganisationIntegrationInput;
}>;


export type IntegrationSettings_UpdateMutation = { updateOrganisationIntegration: { __typename: 'UpdateOrganisationIntegrationResult', organisationIntegration: { __typename: 'OrganisationIntegration', id: string, settings: any } } };

export type IntegrationSettings_RemoveMutationVariables = Types.Exact<{
  input: Types.RemoveOrganisationIntegrationInput;
}>;


export type IntegrationSettings_RemoveMutation = { removeOrganisationIntegration: { __typename: 'RemoveOrganisationIntegrationResult', ok?: boolean | null } };

export type IntegrationSettings_SetPdsBearerTokenMutationVariables = Types.Exact<{
  token: Types.SetPdsBearerTokenInput;
}>;


export type IntegrationSettings_SetPdsBearerTokenMutation = { setPdsBearerToken: { __typename: 'SetPdsBearerTokenResult', ok: boolean } };

export type IntegrationSettings_GetPdsBearerTokenQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type IntegrationSettings_GetPdsBearerTokenQuery = { getPdsBearerToken: { __typename: 'GetPdsBearerTokenResult', bearerToken?: string | null } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type IntegrationSettings_M1LeadResponseQueryVariables = Types.Exact<{
  leadId: Types.Scalars['Int']['input'];
}>;


export type IntegrationSettings_M1LeadResponseQuery = { m1ApiLeadResponse: { __typename: 'M1ApiLeadResponseResult', response?: any | null } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };


export const IntegrationSettings_AddDocument = gql`
    mutation IntegrationSettings_Add($input: AddOrganisationIntegrationInput!) {
  addOrganisationIntegration(input: $input) {
    organisationIntegration {
      id
      integration {
        integrationId
      }
      settings
    }
  }
}
    `;
export type IntegrationSettings_AddMutationFn = Apollo.MutationFunction<IntegrationSettings_AddMutation, IntegrationSettings_AddMutationVariables>;

/**
 * __useIntegrationSettings_AddMutation__
 *
 * To run a mutation, you first call `useIntegrationSettings_AddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettings_AddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationSettingsAddMutation, { data, loading, error }] = useIntegrationSettings_AddMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationSettings_AddMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationSettings_AddMutation, IntegrationSettings_AddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationSettings_AddMutation, IntegrationSettings_AddMutationVariables>(IntegrationSettings_AddDocument, options);
      }
export type IntegrationSettings_AddMutationHookResult = ReturnType<typeof useIntegrationSettings_AddMutation>;
export type IntegrationSettings_AddMutationResult = Apollo.MutationResult<IntegrationSettings_AddMutation>;
export type IntegrationSettings_AddMutationOptions = Apollo.BaseMutationOptions<IntegrationSettings_AddMutation, IntegrationSettings_AddMutationVariables>;
export const IntegrationSettings_UpdateDocument = gql`
    mutation IntegrationSettings_Update($input: UpdateOrganisationIntegrationInput!) {
  updateOrganisationIntegration(input: $input) {
    organisationIntegration {
      id
      settings
    }
  }
}
    `;
export type IntegrationSettings_UpdateMutationFn = Apollo.MutationFunction<IntegrationSettings_UpdateMutation, IntegrationSettings_UpdateMutationVariables>;

/**
 * __useIntegrationSettings_UpdateMutation__
 *
 * To run a mutation, you first call `useIntegrationSettings_UpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettings_UpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationSettingsUpdateMutation, { data, loading, error }] = useIntegrationSettings_UpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationSettings_UpdateMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationSettings_UpdateMutation, IntegrationSettings_UpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationSettings_UpdateMutation, IntegrationSettings_UpdateMutationVariables>(IntegrationSettings_UpdateDocument, options);
      }
export type IntegrationSettings_UpdateMutationHookResult = ReturnType<typeof useIntegrationSettings_UpdateMutation>;
export type IntegrationSettings_UpdateMutationResult = Apollo.MutationResult<IntegrationSettings_UpdateMutation>;
export type IntegrationSettings_UpdateMutationOptions = Apollo.BaseMutationOptions<IntegrationSettings_UpdateMutation, IntegrationSettings_UpdateMutationVariables>;
export const IntegrationSettings_RemoveDocument = gql`
    mutation IntegrationSettings_Remove($input: RemoveOrganisationIntegrationInput!) {
  removeOrganisationIntegration(input: $input) {
    ok
  }
}
    `;
export type IntegrationSettings_RemoveMutationFn = Apollo.MutationFunction<IntegrationSettings_RemoveMutation, IntegrationSettings_RemoveMutationVariables>;

/**
 * __useIntegrationSettings_RemoveMutation__
 *
 * To run a mutation, you first call `useIntegrationSettings_RemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettings_RemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationSettingsRemoveMutation, { data, loading, error }] = useIntegrationSettings_RemoveMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIntegrationSettings_RemoveMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationSettings_RemoveMutation, IntegrationSettings_RemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationSettings_RemoveMutation, IntegrationSettings_RemoveMutationVariables>(IntegrationSettings_RemoveDocument, options);
      }
export type IntegrationSettings_RemoveMutationHookResult = ReturnType<typeof useIntegrationSettings_RemoveMutation>;
export type IntegrationSettings_RemoveMutationResult = Apollo.MutationResult<IntegrationSettings_RemoveMutation>;
export type IntegrationSettings_RemoveMutationOptions = Apollo.BaseMutationOptions<IntegrationSettings_RemoveMutation, IntegrationSettings_RemoveMutationVariables>;
export const IntegrationSettings_SetPdsBearerTokenDocument = gql`
    mutation IntegrationSettings_SetPdsBearerToken($token: SetPdsBearerTokenInput!) {
  setPdsBearerToken(input: $token) {
    ok
  }
}
    `;
export type IntegrationSettings_SetPdsBearerTokenMutationFn = Apollo.MutationFunction<IntegrationSettings_SetPdsBearerTokenMutation, IntegrationSettings_SetPdsBearerTokenMutationVariables>;

/**
 * __useIntegrationSettings_SetPdsBearerTokenMutation__
 *
 * To run a mutation, you first call `useIntegrationSettings_SetPdsBearerTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettings_SetPdsBearerTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [integrationSettingsSetPdsBearerTokenMutation, { data, loading, error }] = useIntegrationSettings_SetPdsBearerTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useIntegrationSettings_SetPdsBearerTokenMutation(baseOptions?: Apollo.MutationHookOptions<IntegrationSettings_SetPdsBearerTokenMutation, IntegrationSettings_SetPdsBearerTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<IntegrationSettings_SetPdsBearerTokenMutation, IntegrationSettings_SetPdsBearerTokenMutationVariables>(IntegrationSettings_SetPdsBearerTokenDocument, options);
      }
export type IntegrationSettings_SetPdsBearerTokenMutationHookResult = ReturnType<typeof useIntegrationSettings_SetPdsBearerTokenMutation>;
export type IntegrationSettings_SetPdsBearerTokenMutationResult = Apollo.MutationResult<IntegrationSettings_SetPdsBearerTokenMutation>;
export type IntegrationSettings_SetPdsBearerTokenMutationOptions = Apollo.BaseMutationOptions<IntegrationSettings_SetPdsBearerTokenMutation, IntegrationSettings_SetPdsBearerTokenMutationVariables>;
export const IntegrationSettings_GetPdsBearerTokenDocument = gql`
    query IntegrationSettings_GetPdsBearerToken {
  getPdsBearerToken {
    ... on GetPdsBearerTokenResult {
      bearerToken
    }
  }
}
    `;

/**
 * __useIntegrationSettings_GetPdsBearerTokenQuery__
 *
 * To run a query within a React component, call `useIntegrationSettings_GetPdsBearerTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettings_GetPdsBearerTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationSettings_GetPdsBearerTokenQuery({
 *   variables: {
 *   },
 * });
 */
export function useIntegrationSettings_GetPdsBearerTokenQuery(baseOptions?: Apollo.QueryHookOptions<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>(IntegrationSettings_GetPdsBearerTokenDocument, options);
      }
export function useIntegrationSettings_GetPdsBearerTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>(IntegrationSettings_GetPdsBearerTokenDocument, options);
        }
export function useIntegrationSettings_GetPdsBearerTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>(IntegrationSettings_GetPdsBearerTokenDocument, options);
        }
export type IntegrationSettings_GetPdsBearerTokenQueryHookResult = ReturnType<typeof useIntegrationSettings_GetPdsBearerTokenQuery>;
export type IntegrationSettings_GetPdsBearerTokenLazyQueryHookResult = ReturnType<typeof useIntegrationSettings_GetPdsBearerTokenLazyQuery>;
export type IntegrationSettings_GetPdsBearerTokenSuspenseQueryHookResult = ReturnType<typeof useIntegrationSettings_GetPdsBearerTokenSuspenseQuery>;
export type IntegrationSettings_GetPdsBearerTokenQueryResult = Apollo.QueryResult<IntegrationSettings_GetPdsBearerTokenQuery, IntegrationSettings_GetPdsBearerTokenQueryVariables>;
export const IntegrationSettings_M1LeadResponseDocument = gql`
    query IntegrationSettings_M1LeadResponse($leadId: Int!) {
  m1ApiLeadResponse(leadId: $leadId) {
    ... on M1ApiLeadResponseResult {
      response
    }
  }
}
    `;

/**
 * __useIntegrationSettings_M1LeadResponseQuery__
 *
 * To run a query within a React component, call `useIntegrationSettings_M1LeadResponseQuery` and pass it any options that fit your needs.
 * When your component renders, `useIntegrationSettings_M1LeadResponseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIntegrationSettings_M1LeadResponseQuery({
 *   variables: {
 *      leadId: // value for 'leadId'
 *   },
 * });
 */
export function useIntegrationSettings_M1LeadResponseQuery(baseOptions: Apollo.QueryHookOptions<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables> & ({ variables: IntegrationSettings_M1LeadResponseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables>(IntegrationSettings_M1LeadResponseDocument, options);
      }
export function useIntegrationSettings_M1LeadResponseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables>(IntegrationSettings_M1LeadResponseDocument, options);
        }
export function useIntegrationSettings_M1LeadResponseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables>(IntegrationSettings_M1LeadResponseDocument, options);
        }
export type IntegrationSettings_M1LeadResponseQueryHookResult = ReturnType<typeof useIntegrationSettings_M1LeadResponseQuery>;
export type IntegrationSettings_M1LeadResponseLazyQueryHookResult = ReturnType<typeof useIntegrationSettings_M1LeadResponseLazyQuery>;
export type IntegrationSettings_M1LeadResponseSuspenseQueryHookResult = ReturnType<typeof useIntegrationSettings_M1LeadResponseSuspenseQuery>;
export type IntegrationSettings_M1LeadResponseQueryResult = Apollo.QueryResult<IntegrationSettings_M1LeadResponseQuery, IntegrationSettings_M1LeadResponseQueryVariables>;